var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIconOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2709_26791)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.12509C0 2.26115 1.51102 0.750122 3.37496 0.750122L11.4429 0.750122C12.3379 0.750122 13.1964 1.1057 13.8293 1.73863L17.0113 4.92058C17.6441 5.55351 17.9998 6.41195 17.9998 7.30704L17.9998 19.8749C17.9998 21.739 16.4888 23.2499 14.6248 23.2499L3.37496 23.2499C1.51102 23.2499 0 21.739 0 19.8749L0 4.12509ZM3.37496 3.0001C2.75365 3.0001 2.24997 3.50378 2.24997 4.12509L2.24997 19.8749C2.24997 20.4962 2.75365 20.9999 3.37496 20.9999L14.6248 20.9999C15.2461 20.9999 15.7498 20.4962 15.7498 19.8749L15.7498 7.30704C15.7498 7.00868 15.6312 6.72253 15.4203 6.51155L12.2384 3.3296C12.0273 3.11863 11.7413 3.0001 11.4429 3.0001L3.37496 3.0001Z",
    fill: "#CD951B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37499 3.00012C2.75368 3.00012 2.25 3.5038 2.25 4.12511L2.25 19.875C2.25 20.4963 2.75368 21 3.37499 21L14.6248 21C15.2461 21 15.7498 20.4963 15.7498 19.875L15.7498 7.30706C15.7498 7.0087 15.6312 6.72255 15.4203 6.51157L12.2384 3.32962C12.0274 3.11865 11.7413 3.00012 11.4429 3.00012L3.37499 3.00012ZM5.62496 8.62507C5.00365 8.62507 4.49997 9.12875 4.49997 9.75006C4.49997 10.3714 5.00365 10.875 5.62496 10.875L12.3749 10.875C12.9962 10.875 13.4999 10.3714 13.4999 9.75006C13.4999 9.12875 12.9962 8.62507 12.3749 8.62507L5.62496 8.62507ZM5.62496 13.125C5.00365 13.125 4.49997 13.6287 4.49997 14.25C4.49997 14.8713 5.00365 15.375 5.62496 15.375L10.1249 15.375C10.7462 15.375 11.2499 14.8713 11.2499 14.25C11.2499 13.6287 10.7462 13.125 10.1249 13.125L5.62496 13.125Z",
    fill: "#CD951B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.74999C4.5 9.12868 5.00368 8.625 5.62499 8.625L12.3749 8.625C12.9962 8.625 13.4999 9.12868 13.4999 9.74999C13.4999 10.3713 12.9962 10.875 12.3749 10.875L5.62499 10.875C5.00368 10.875 4.5 10.3713 4.5 9.74999Z",
    fill: "#CD951B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.25C4.5 13.6287 5.00368 13.125 5.62499 13.125L10.1249 13.125C10.7463 13.125 11.2499 13.6287 11.2499 14.25C11.2499 14.8713 10.7463 15.375 10.1249 15.375L5.62499 15.375C5.00368 15.375 4.5 14.8713 4.5 14.25Z",
    fill: "#CD951B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2709_26791",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.12509C0 2.26115 1.51102 0.750122 3.37496 0.750122L11.4429 0.750122C12.3379 0.750122 13.1964 1.1057 13.8293 1.73863L17.0113 4.92058C17.6441 5.55351 17.9998 6.41195 17.9998 7.30704L17.9998 19.8749C17.9998 21.739 16.4888 23.2499 14.6248 23.2499L3.37496 23.2499C1.51102 23.2499 0 21.739 0 19.8749L0 4.12509ZM3.37496 3.0001C2.75365 3.0001 2.24997 3.50378 2.24997 4.12509L2.24997 19.8749C2.24997 20.4962 2.75365 20.9999 3.37496 20.9999L14.6248 20.9999C15.2461 20.9999 15.7498 20.4962 15.7498 19.8749L15.7498 7.30704C15.7498 7.00868 15.6312 6.72253 15.4203 6.51155L12.2384 3.3296C12.0273 3.11863 11.7413 3.0001 11.4429 3.0001L3.37496 3.0001Z",
    fill: "#CD951B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37499 3.00012C2.75368 3.00012 2.25 3.5038 2.25 4.12511L2.25 19.875C2.25 20.4963 2.75368 21 3.37499 21L14.6248 21C15.2461 21 15.7498 20.4963 15.7498 19.875L15.7498 7.30706C15.7498 7.0087 15.6312 6.72255 15.4203 6.51157L12.2384 3.32962C12.0274 3.11865 11.7413 3.00012 11.4429 3.00012L3.37499 3.00012ZM5.62496 8.62507C5.00365 8.62507 4.49997 9.12875 4.49997 9.75006C4.49997 10.3714 5.00365 10.875 5.62496 10.875L12.3749 10.875C12.9962 10.875 13.4999 10.3714 13.4999 9.75006C13.4999 9.12875 12.9962 8.62507 12.3749 8.62507L5.62496 8.62507ZM5.62496 13.125C5.00365 13.125 4.49997 13.6287 4.49997 14.25C4.49997 14.8713 5.00365 15.375 5.62496 15.375L10.1249 15.375C10.7462 15.375 11.2499 14.8713 11.2499 14.25C11.2499 13.6287 10.7462 13.125 10.1249 13.125L5.62496 13.125Z",
    fill: "#CD951B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.74999C4.5 9.12868 5.00368 8.625 5.62499 8.625L12.3749 8.625C12.9962 8.625 13.4999 9.12868 13.4999 9.74999C13.4999 10.3713 12.9962 10.875 12.3749 10.875L5.62499 10.875C5.00368 10.875 4.5 10.3713 4.5 9.74999Z",
    fill: "#CD951B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.25C4.5 13.6287 5.00368 13.125 5.62499 13.125L10.1249 13.125C10.7463 13.125 11.2499 13.6287 11.2499 14.25C11.2499 14.8713 10.7463 15.375 10.1249 15.375L5.62499 15.375C5.00368 15.375 4.5 14.8713 4.5 14.25Z",
    fill: "#CD951B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2709_26791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 18.88L3.10316 14.3647C4.23975 13.2498 6.08808 13.2076 7.27789 14.2696L16.4998 22.4999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68749 6.56262C5.30879 6.56262 5.81247 7.0663 5.81247 7.68761C5.81247 8.30892 5.30879 8.8126 4.68749 8.8126C4.06618 8.8126 3.5625 8.30892 3.5625 7.68761C3.5625 7.0663 4.06618 6.56262 4.68749 6.56262Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2709_26791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9998,
    height: 22.4998,
    fill: "white",
    transform: "translate(0 0.750122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIconOrange);
export default __webpack_public_path__ + "static/media/ImageIconOrange.e6154c8acd7cb551584c548ddb52f6fd.svg";
export { ForwardRef as ReactComponent };